export default "__VITE_ASSET__zE09AbEh__ 480w, __VITE_ASSET__DpZksLwl__ 768w, __VITE_ASSET__Csdx6Edd__ 1200w, __VITE_ASSET__0qihhOqm__ 1920w";